import { useSetActiveBreakdownDocument } from '@/hooks/useBreakdownDocuments';
import { ConfirmDialog } from './ConfirmDialog';

export interface SetActiveConfirmProps {
  jobId: string;
  document: { id: string; name: string } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirmed?: () => void;
}

// Promoting a document to Active is gated by confirmation because Active
// drives invoice generation, job-card exports, and other downstream
// consumers — a misclick from the dropdown would otherwise silently change
// what gets billed.
export function SetActiveConfirm({
  jobId,
  document,
  open,
  onOpenChange,
  onConfirmed,
}: SetActiveConfirmProps) {
  const setActive = useSetActiveBreakdownDocument(jobId);

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Set as Active version"
      description={
        <>
          Set <strong>{document?.name ?? ''}</strong> as Active? Invoices and
          exports will use this version.
        </>
      }
      confirmLabel="Set as Active"
      confirmingLabel="Setting active..."
      confirmDisabled={!document}
      onConfirm={async () => {
        if (!document) return;
        await setActive.mutateAsync(document.id);
        onConfirmed?.();
      }}
    />
  );
}
